export default __webpack_public_path__ + "static/media/corporate-banner.700f2473.webp";